import { useState, useEffect, useCallback } from 'react';
import ReportsService from '@/services/reportsService';

export default function useHourlySales() {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({
    totalOrders: 0,
    totalSales: 0,
    peakHour: '',
    peakSales: 0,
  });
  const [branchSummary, setBranchSummary] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    period: 'this_month',
    startDate: null,
    endDate: null,
    offset: 0,
    limit: 24,
    sortColumn: 'net_sales',
    sortDirection: 'DESC',
  });

  const fetchHourlySales = useCallback(async () => {
    try {
      setLoading(true);

      const params = {
        offset: filters.offset,
        limit: filters.limit,
        sortColumn: filters.sortColumn,
        sortDirection: filters.sortDirection,
      };

      if (filters.branchId) params.branchId = filters.branchId;

      if (filters.period) params.period = filters.period;
      if (!filters.period && filters.startDate && filters.endDate) {
        params.startDate = filters.startDate;
        params.endDate = filters.endDate;
      }

      const res = await ReportsService.getHourlySales(params);
      const apiData = res?.data ?? res;

      const rows =
        apiData?.table?.content?.map(row => ({
          id: row.hourNo,
          hour_label: row.hourLabel,
          orders: Number(row.orders ?? 0),
          items_sold: Number(row.itemsSold ?? 0),
          gross_sales: Number(row.grossSales ?? 0),
          net_sales: Number(row.netSales ?? 0),
          avg_order: Number(row.avgOrder ?? 0),
          branchId: row.branchId,
        })) ?? [];

      setData(rows);

      setSummary({
        totalOrders: Number(apiData?.summary?.totalOrders ?? 0),
        totalSales: Number(apiData?.summary?.totalSales ?? 0),
        peakHour: apiData?.summary?.peakHour ?? '',
        peakSales: Number(apiData?.summary?.peakSales ?? 0),
      });

      setBranchSummary(apiData?.branchSummary ?? []);
      setTotalItems(apiData?.table?.totalElements ?? 0);
    } catch (err) {
      console.error('useHourlySales ERROR:', err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchHourlySales();
  }, [fetchHourlySales]);

  return {
    data,
    summary,
    branchSummary,
    totalItems,
    loading,
    setFilters,
  };
}
